










































































import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import store from "../store";
import { NfProduct, Nfce } from "../types";
import { Base64 } from "js-base64";

@Component
export default class History extends Vue {
  nfces: Array<Nfce> = [];
  formUp = false;
  form = { why: "" };
  id = 0;
  blocked = false;
  rule = {
    why: [
      {
        required: true,
        message: "A justificativa é obrigatoria",
        trigger: "change"
      },
      {
        min: 15,
        message: "Minimo de 15 caracteres",
        trigger: "change"
      }
    ]
  };

  beforeCreate() {
    Axios.get(`https://api.clubdobalanco.com/v1/nfce/0`, {
      headers: { Authorization: store.state.passwd }
    }).then((r: any) => {
      (r.data as Array<Nfce>).forEach(r => {
        try {
          r.status!.danfe = Base64.decode(r.status!.danfe);
        } catch (e) {
          r.status!.danfe = "Contate o suporte";
        }
      });
      this.nfces = r.data;
    });
  }

  print(e: any) {
    const iframe = document.getElementById("print") as HTMLIFrameElement;
    iframe.srcdoc = e;
    setTimeout(() => iframe.contentWindow!.print(), 50);
  }

  async cancelNfce() {
    this.blocked = true;

    let valid;
    (this.$refs.form as Vue & {
      validate(
        Callback: (isValid: boolean, invalidFields?: object) => void
      ): void;
    }).validate(v => {
      valid = v;
    });

    if (valid) {
      try {
        const r = await Axios.delete(
          `https://api.clubdobalanco.com/v1/nfce/${this.id}`,
          {
            headers: { Authorization: store.state.passwd },
            data: { why: this.form.why }
          }
        );

        if (r.data.status == "erro_cancelamento") {
          this.$notify({
            title: "Rejeitado pela SEFAZ",
            message: r.data.mensagem_sefaz,
            type: "warning"
          });
        } else {
          this.$notify({
            title: "Aprovado pela SEFAZ",
            message: r.data.mensagem_sefaz,
            type: "success"
          });
        }
      } catch (err) {
        this.$notify.error({
          title: "Algo deu errado",
          message: err
        });
      }
      this.formUp = false;
    }

    this.blocked = false;
  }
}
